var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Route } from 'react-router-dom';
import { theme } from './styled';
import * as helpers from './helpers';
export const getProgressData = (type, theme, progressTranslation) => {
    switch (type) {
        case 'signed':
            return {
                theme: theme.green,
                width: 100,
                text: progressTranslation[type],
            };
        case 'error':
            return { theme: theme.red, width: 100, text: progressTranslation[type] };
        default:
            return {
                theme: theme.yellow,
                width: 50,
                text: progressTranslation[type],
            };
    }
};
export const topBarColor = (type) => {
    if (type === 'signed') {
        return theme.green;
    }
    if (type === 'view') {
        return theme.vDarkGray;
    }
    if (type === 'error') {
        return theme.red;
    }
    return theme.green;
};
export const color = (state) => {
    if (state === 'invalid') {
        return theme.red;
    }
    if (state === 'valid') {
        return theme.green;
    }
    return theme.lightGray;
};
export function formatColor(msg) {
    console.error('DEPRECETED! - import formatColor from helpers, not from utils.');
    return helpers.formatColor(msg);
}
export function textWithBold(msg) {
    console.error('DEPRECETED! - import textWithBold from helpers, not from utils.');
    return helpers.textWithBold(msg);
}
export function textWithLinks(msg) {
    console.error('DEPRECETED! - import textWithLinks from helpers, not from utils.');
    return helpers.textWithLinks(msg);
}
export function isValid(val, pattern) {
    const re = new RegExp(pattern);
    return re.test(val);
}
export const isAllInputsValid = (states) => {
    if (states.length > 0) {
        const valid = states.filter((state) => state === true);
        return valid.length === states.length;
    }
    return false;
};
export function checkIfMobile(navigator) {
    if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true;
    }
    return false;
}
export function checkIfIPhone(navigator) {
    if (navigator.userAgent.match(/iPhone/i)) {
        return true;
    }
    return false;
}
export function unsupportedBrowsers(navigator) {
    var ua = navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
    }
    else {
        return false;
    }
}
export function parsedCountriesList(data, translation) {
    const parsedData = data
        .map((item, i) => {
        const idx = translation.findIndex((transItem) => transItem.code === item.cca2);
        return {
            label: translation[idx].name_pl,
            value: item.cca2,
            phone: `+${item.callingCode[0] || ''}`,
        };
    })
        .sort((a, b) => {
        if (a.label < b.label)
            return -1;
        if (a.label > b.label)
            return 1;
        return 0;
    });
    return parsedData;
}
export const getCookieDomain = (domain) => {
    switch (domain) {
        case 'development':
            return '.lcl.autenti.net';
        case 'accept':
            return '.accept.autenti.net';
        case 'production':
            return '.autenti.com';
        default:
            return '';
    }
};
export const getUrlTo = (app) => {
    if (!window['autentiConfig'])
        throw new Error('Cannot find autentiConfig property to resolve url');
    switch (app) {
        case 'accounts':
            return window['autentiConfig'].accountsApp;
        case 'classicsign':
            return window['autentiConfig'].classicsignApp;
        case 'create':
            return window['autentiConfig'].createApp;
        case 'docs':
            return window['autentiConfig'].docsApp;
        case 'sign':
            return window['autentiConfig'].signApp;
        case 'onboarding':
            return window['autentiConfig'].onboardingApp;
        case 'templates':
            return window['autentiConfig'].templatesApp;
        case 'broker':
            return window['autentiConfig'].brokerApp;
        case 'eid':
            return window['autentiConfig'].eidApp;
        case 'verify':
            return window['autentiConfig'].verifyApp;
        case 'validator':
            return window['autentiConfig'].validatorApp;
        case 'addressbook':
            return window['autentiConfig'].addressbookApp;
        case 'edelivery':
            return window['autentiConfig'].edeliveryApp;
        case 'processes':
            return window['autentiConfig'].processesApp;
        case 'dashboard':
            return window['autentiConfig'].dashboardApp;
        case 'creator':
            return window['autentiConfig'].creatorApp;
        default:
            return window['autentiConfig'].accountsApp;
    }
};
export const Authenticated = (_a) => {
    var { component } = _a, rest = __rest(_a, ["component"]);
    return (React.createElement(Route, Object.assign({}, rest, { render: (props) => helpers.hasLoginCookie()
            ? React.createElement(component, Object.assign({}, props))
            : window.location.replace(getUrlTo('accounts')) })));
};
export const getGivenName = (name) => name.split(' ').slice(0, -1).join(' ');
export const getSurnameName = (name) => name.split(' ').slice(-1).join(' ');
export const getFirstLetter = (text) => text && text.length ? text[0] : '';
export const getPercentage = (val, total) => (val / total) * 100;
export const getBestSortOptionForUser = (user) => {
    if (user.givenName && user.surname)
        return `${user.givenName} ${user.surname}`;
    if (user.givenName)
        return user.givenName;
    if (user.surname)
        return user.surname;
    if (user.email)
        return user.email;
    return '';
};
export const sortListBy = (users) => users.sort((a, b) => {
    const val1 = getBestSortOptionForUser(a).toLowerCase();
    const val2 = getBestSortOptionForUser(b).toLowerCase();
    return val1 > val2 ? 1 : val1 > val2 ? -1 : 0;
});
export const getOrganizationsName = (users) => users.reduce((all, val, index) => {
    if (val &&
        val.organization &&
        all.filter((o) => o.name === val.organization.name).length === 0) {
        all.push(val.organization);
    }
    return all;
}, []);
export const getUsersByOrganization = (users, organization) => users.filter((val) => val.organization && val.organization.name === organization);
export const getUsersWithoutOrganization = (users) => users.filter((val) => val && !val.organization);
export const isUserSigned = (user) => user.decision && user.decision.result === 'SIGNED';
export const isUserApproved = (user) => user.decision && user.decision.result === 'CONSENTED';
export const isUserEnqueued = (user) => user.decision && user.decision.result === 'ENQUEUED';
export const isViewer = (user, viewers) => viewers.filter((val) => user.email === val.email).length > 0;
export const isApprover = (user, approvers) => approvers.filter((val) => user.email === val.email).length > 0;
export const isReviewer = (user, reviewers) => reviewers.filter((val) => user.email === val.email).length > 0;
export const getUniqueUsers = (users) => users.reduce((all, val) => {
    if (val &&
        val.email &&
        all.filter((o) => o.email === val.email).length === 0) {
        all.push(val);
    }
    return all;
}, []);
export const getCurrentUser = (users) => users.filter((val) => val && val.currentUser);
export const determineIfCurrentUrl = (url) => window.location.host.includes(url);
export const shouldSeeValidatorLink = (sender) => {
    const autenti = /@autenti.com/gim;
    const autentiEu = /@autenti.eu/gim;
    const bnp = /@bnpparibas.pl/gim;
    return Boolean(sender.match(autenti) || sender.match(autentiEu) || sender.match(bnp));
};
export const isLanguagePolish = (lang) => lang.toLowerCase() === 'pl';
